const expirationMonthsCodes = [
  {
    month: 'JAN',
    code: 'MN',
    tip: 'January or M, N',
    monthNum: 1,
  },
  {
    month: 'FEB',
    code: 'OPQ',
    tip: 'February or O, P, Q',
    monthNum: 2,
  },
  {
    month: 'MAR',
    code: 'RSTU',
    tip: 'March or R, S, T, U',
    monthNum: 3,
  },
  {
    month: 'APR',
    code: 'V',
    tip: 'April or V',
    monthNum: 4,
  },
  {
    month: 'MAY',
    code: 'WXYZ',
    tip: 'May or W, X, Y, Z',
    monthNum: 5,
  },
  {
    month: 'JUN',
    code: 'A#',
    tip: 'June or A, or All Numeric',
    monthNum: 6,
  },
  {
    month: 'JUL',
    code: 'BC',
    tip: 'July or B, C',
    monthNum: 7,
  },
  {
    month: 'AUG',
    code: 'DE',
    tip: 'August or D, E',
    monthNum: 8,
  },
  {
    month: 'SEP',
    code: 'F',
    tip: 'September or F',
    monthNum: 9,
  },
  {
    month: 'OCT',
    code: 'G',
    tip: 'October or G',
    monthNum: 10,
  },
  {
    month: 'NOV',
    code: 'HIJ',
    tip: 'November or H, I, J',
    monthNum: 11,
  },
  {
    month: 'DEC',
    code: 'KL',
    tip: 'December or K, L',
    monthNum: 12,
  },
];

export default expirationMonthsCodes;
